import { render } from "./PromoRegister.vue?vue&type=template&id=9dea280e&scoped=true&ts=true"
import script from "./PromoRegister.vue?vue&type=script&lang=ts"
export * from "./PromoRegister.vue?vue&type=script&lang=ts"

import "./PromoRegister.vue?vue&type=style&index=0&id=9dea280e&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9dea280e"]])

export default __exports__